module.exports = __webpack_public_path__ + "img/association_map.b88ab8f0.svg";